/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TelegramConnectRouteImport } from './routes/telegram/connect'
import { Route as LoginSignupRouteImport } from './routes/_login/signup'
import { Route as LoginOtpRouteImport } from './routes/_login/otp'
import { Route as LoginLoginRouteImport } from './routes/_login/login'
import { Route as LoginForgetPasswordRouteImport } from './routes/_login/forgetPassword'
import { Route as DashboardDashboardRouteImport } from './routes/_dashboard/dashboard'
import { Route as DashboardWalletIndexRouteImport } from './routes/_dashboard/wallet/index'
import { Route as DashboardSellCoinIndexRouteImport } from './routes/_dashboard/sell-coin/index'
import { Route as DashboardProfileIndexRouteImport } from './routes/_dashboard/profile/index'
import { Route as DashboardPaymentHistoryIndexRouteImport } from './routes/_dashboard/payment-history/index'
import { Route as DashboardHistoryIndexRouteImport } from './routes/_dashboard/history/index'
import { Route as DashboardProfileTransferMultiplierGuideRouteImport } from './routes/_dashboard/profile/transfer-multiplier-guide'
import { Route as DashboardAdminUsersIndexRouteImport } from './routes/_dashboard/admin/users/index'
import { Route as DashboardAdminSettingsIndexRouteImport } from './routes/_dashboard/admin/settings/index'
import { Route as DashboardAdminProfileIndexRouteImport } from './routes/_dashboard/admin/profile/index'
import { Route as DashboardAdminPlayerAuctionIndexRouteImport } from './routes/_dashboard/admin/player-auction/index'
import { Route as DashboardAdminFinancialReportIndexRouteImport } from './routes/_dashboard/admin/financial-report/index'
import { Route as DashboardAdminFastSellIndexRouteImport } from './routes/_dashboard/admin/fast-sell/index'
import { Route as DashboardAdminDashboardIndexRouteImport } from './routes/_dashboard/admin/dashboard/index'
import { Route as DashboardAdminComfortTradeIndexRouteImport } from './routes/_dashboard/admin/comfort-trade/index'
import { Route as DashboardAdminBannersIndexRouteImport } from './routes/_dashboard/admin/banners/index'
import { Route as DashboardAdminUsersUserIdRouteImport } from './routes/_dashboard/admin/users/$userId'
import { Route as DashboardAdminPlayerAuctionSendersSenderIdRouteImport } from './routes/_dashboard/admin/player-auction/senders/$senderId'
import { Route as DashboardAdminComfortTradeSendersSenderEmailRouteImport } from './routes/_dashboard/admin/comfort-trade/senders/$senderEmail'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramConnectRoute = TelegramConnectRouteImport.update({
  id: '/telegram/connect',
  path: '/telegram/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSignupRoute = LoginSignupRouteImport.update({
  id: '/_login/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginOtpRoute = LoginOtpRouteImport.update({
  id: '/_login/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLoginRoute = LoginLoginRouteImport.update({
  id: '/_login/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginForgetPasswordRoute = LoginForgetPasswordRouteImport.update({
  id: '/_login/forgetPassword',
  path: '/forgetPassword',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardDashboardRoute = DashboardDashboardRouteImport.update({
  id: '/_dashboard/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardWalletIndexRoute = DashboardWalletIndexRouteImport.update({
  id: '/_dashboard/wallet/',
  path: '/wallet/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSellCoinIndexRoute = DashboardSellCoinIndexRouteImport.update({
  id: '/_dashboard/sell-coin/',
  path: '/sell-coin/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardProfileIndexRoute = DashboardProfileIndexRouteImport.update({
  id: '/_dashboard/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPaymentHistoryIndexRoute =
  DashboardPaymentHistoryIndexRouteImport.update({
    id: '/_dashboard/payment-history/',
    path: '/payment-history/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardHistoryIndexRoute = DashboardHistoryIndexRouteImport.update({
  id: '/_dashboard/history/',
  path: '/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardProfileTransferMultiplierGuideRoute =
  DashboardProfileTransferMultiplierGuideRouteImport.update({
    id: '/_dashboard/profile/transfer-multiplier-guide',
    path: '/profile/transfer-multiplier-guide',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminUsersIndexRoute =
  DashboardAdminUsersIndexRouteImport.update({
    id: '/_dashboard/admin/users/',
    path: '/admin/users/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminSettingsIndexRoute =
  DashboardAdminSettingsIndexRouteImport.update({
    id: '/_dashboard/admin/settings/',
    path: '/admin/settings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminProfileIndexRoute =
  DashboardAdminProfileIndexRouteImport.update({
    id: '/_dashboard/admin/profile/',
    path: '/admin/profile/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminPlayerAuctionIndexRoute =
  DashboardAdminPlayerAuctionIndexRouteImport.update({
    id: '/_dashboard/admin/player-auction/',
    path: '/admin/player-auction/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminFinancialReportIndexRoute =
  DashboardAdminFinancialReportIndexRouteImport.update({
    id: '/_dashboard/admin/financial-report/',
    path: '/admin/financial-report/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminFastSellIndexRoute =
  DashboardAdminFastSellIndexRouteImport.update({
    id: '/_dashboard/admin/fast-sell/',
    path: '/admin/fast-sell/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminDashboardIndexRoute =
  DashboardAdminDashboardIndexRouteImport.update({
    id: '/_dashboard/admin/dashboard/',
    path: '/admin/dashboard/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminComfortTradeIndexRoute =
  DashboardAdminComfortTradeIndexRouteImport.update({
    id: '/_dashboard/admin/comfort-trade/',
    path: '/admin/comfort-trade/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminBannersIndexRoute =
  DashboardAdminBannersIndexRouteImport.update({
    id: '/_dashboard/admin/banners/',
    path: '/admin/banners/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminUsersUserIdRoute =
  DashboardAdminUsersUserIdRouteImport.update({
    id: '/_dashboard/admin/users/$userId',
    path: '/admin/users/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminPlayerAuctionSendersSenderIdRoute =
  DashboardAdminPlayerAuctionSendersSenderIdRouteImport.update({
    id: '/_dashboard/admin/player-auction/senders/$senderId',
    path: '/admin/player-auction/senders/$senderId',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminComfortTradeSendersSenderEmailRoute =
  DashboardAdminComfortTradeSendersSenderEmailRouteImport.update({
    id: '/_dashboard/admin/comfort-trade/senders/$senderEmail',
    path: '/admin/comfort-trade/senders/$senderEmail',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/forgetPassword': typeof LoginForgetPasswordRoute
  '/login': typeof LoginLoginRoute
  '/otp': typeof LoginOtpRoute
  '/signup': typeof LoginSignupRoute
  '/telegram/connect': typeof TelegramConnectRoute
  '/profile/transfer-multiplier-guide': typeof DashboardProfileTransferMultiplierGuideRoute
  '/history/': typeof DashboardHistoryIndexRoute
  '/payment-history/': typeof DashboardPaymentHistoryIndexRoute
  '/profile/': typeof DashboardProfileIndexRoute
  '/sell-coin/': typeof DashboardSellCoinIndexRoute
  '/wallet/': typeof DashboardWalletIndexRoute
  '/admin/users/$userId': typeof DashboardAdminUsersUserIdRoute
  '/admin/banners/': typeof DashboardAdminBannersIndexRoute
  '/admin/comfort-trade/': typeof DashboardAdminComfortTradeIndexRoute
  '/admin/dashboard/': typeof DashboardAdminDashboardIndexRoute
  '/admin/fast-sell/': typeof DashboardAdminFastSellIndexRoute
  '/admin/financial-report/': typeof DashboardAdminFinancialReportIndexRoute
  '/admin/player-auction/': typeof DashboardAdminPlayerAuctionIndexRoute
  '/admin/profile/': typeof DashboardAdminProfileIndexRoute
  '/admin/settings/': typeof DashboardAdminSettingsIndexRoute
  '/admin/users/': typeof DashboardAdminUsersIndexRoute
  '/admin/comfort-trade/senders/$senderEmail': typeof DashboardAdminComfortTradeSendersSenderEmailRoute
  '/admin/player-auction/senders/$senderId': typeof DashboardAdminPlayerAuctionSendersSenderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/forgetPassword': typeof LoginForgetPasswordRoute
  '/login': typeof LoginLoginRoute
  '/otp': typeof LoginOtpRoute
  '/signup': typeof LoginSignupRoute
  '/telegram/connect': typeof TelegramConnectRoute
  '/profile/transfer-multiplier-guide': typeof DashboardProfileTransferMultiplierGuideRoute
  '/history': typeof DashboardHistoryIndexRoute
  '/payment-history': typeof DashboardPaymentHistoryIndexRoute
  '/profile': typeof DashboardProfileIndexRoute
  '/sell-coin': typeof DashboardSellCoinIndexRoute
  '/wallet': typeof DashboardWalletIndexRoute
  '/admin/users/$userId': typeof DashboardAdminUsersUserIdRoute
  '/admin/banners': typeof DashboardAdminBannersIndexRoute
  '/admin/comfort-trade': typeof DashboardAdminComfortTradeIndexRoute
  '/admin/dashboard': typeof DashboardAdminDashboardIndexRoute
  '/admin/fast-sell': typeof DashboardAdminFastSellIndexRoute
  '/admin/financial-report': typeof DashboardAdminFinancialReportIndexRoute
  '/admin/player-auction': typeof DashboardAdminPlayerAuctionIndexRoute
  '/admin/profile': typeof DashboardAdminProfileIndexRoute
  '/admin/settings': typeof DashboardAdminSettingsIndexRoute
  '/admin/users': typeof DashboardAdminUsersIndexRoute
  '/admin/comfort-trade/senders/$senderEmail': typeof DashboardAdminComfortTradeSendersSenderEmailRoute
  '/admin/player-auction/senders/$senderId': typeof DashboardAdminPlayerAuctionSendersSenderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard/dashboard': typeof DashboardDashboardRoute
  '/_login/forgetPassword': typeof LoginForgetPasswordRoute
  '/_login/login': typeof LoginLoginRoute
  '/_login/otp': typeof LoginOtpRoute
  '/_login/signup': typeof LoginSignupRoute
  '/telegram/connect': typeof TelegramConnectRoute
  '/_dashboard/profile/transfer-multiplier-guide': typeof DashboardProfileTransferMultiplierGuideRoute
  '/_dashboard/history/': typeof DashboardHistoryIndexRoute
  '/_dashboard/payment-history/': typeof DashboardPaymentHistoryIndexRoute
  '/_dashboard/profile/': typeof DashboardProfileIndexRoute
  '/_dashboard/sell-coin/': typeof DashboardSellCoinIndexRoute
  '/_dashboard/wallet/': typeof DashboardWalletIndexRoute
  '/_dashboard/admin/users/$userId': typeof DashboardAdminUsersUserIdRoute
  '/_dashboard/admin/banners/': typeof DashboardAdminBannersIndexRoute
  '/_dashboard/admin/comfort-trade/': typeof DashboardAdminComfortTradeIndexRoute
  '/_dashboard/admin/dashboard/': typeof DashboardAdminDashboardIndexRoute
  '/_dashboard/admin/fast-sell/': typeof DashboardAdminFastSellIndexRoute
  '/_dashboard/admin/financial-report/': typeof DashboardAdminFinancialReportIndexRoute
  '/_dashboard/admin/player-auction/': typeof DashboardAdminPlayerAuctionIndexRoute
  '/_dashboard/admin/profile/': typeof DashboardAdminProfileIndexRoute
  '/_dashboard/admin/settings/': typeof DashboardAdminSettingsIndexRoute
  '/_dashboard/admin/users/': typeof DashboardAdminUsersIndexRoute
  '/_dashboard/admin/comfort-trade/senders/$senderEmail': typeof DashboardAdminComfortTradeSendersSenderEmailRoute
  '/_dashboard/admin/player-auction/senders/$senderId': typeof DashboardAdminPlayerAuctionSendersSenderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/forgetPassword'
    | '/login'
    | '/otp'
    | '/signup'
    | '/telegram/connect'
    | '/profile/transfer-multiplier-guide'
    | '/history/'
    | '/payment-history/'
    | '/profile/'
    | '/sell-coin/'
    | '/wallet/'
    | '/admin/users/$userId'
    | '/admin/banners/'
    | '/admin/comfort-trade/'
    | '/admin/dashboard/'
    | '/admin/fast-sell/'
    | '/admin/financial-report/'
    | '/admin/player-auction/'
    | '/admin/profile/'
    | '/admin/settings/'
    | '/admin/users/'
    | '/admin/comfort-trade/senders/$senderEmail'
    | '/admin/player-auction/senders/$senderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/forgetPassword'
    | '/login'
    | '/otp'
    | '/signup'
    | '/telegram/connect'
    | '/profile/transfer-multiplier-guide'
    | '/history'
    | '/payment-history'
    | '/profile'
    | '/sell-coin'
    | '/wallet'
    | '/admin/users/$userId'
    | '/admin/banners'
    | '/admin/comfort-trade'
    | '/admin/dashboard'
    | '/admin/fast-sell'
    | '/admin/financial-report'
    | '/admin/player-auction'
    | '/admin/profile'
    | '/admin/settings'
    | '/admin/users'
    | '/admin/comfort-trade/senders/$senderEmail'
    | '/admin/player-auction/senders/$senderId'
  id:
    | '__root__'
    | '/'
    | '/_dashboard/dashboard'
    | '/_login/forgetPassword'
    | '/_login/login'
    | '/_login/otp'
    | '/_login/signup'
    | '/telegram/connect'
    | '/_dashboard/profile/transfer-multiplier-guide'
    | '/_dashboard/history/'
    | '/_dashboard/payment-history/'
    | '/_dashboard/profile/'
    | '/_dashboard/sell-coin/'
    | '/_dashboard/wallet/'
    | '/_dashboard/admin/users/$userId'
    | '/_dashboard/admin/banners/'
    | '/_dashboard/admin/comfort-trade/'
    | '/_dashboard/admin/dashboard/'
    | '/_dashboard/admin/fast-sell/'
    | '/_dashboard/admin/financial-report/'
    | '/_dashboard/admin/player-auction/'
    | '/_dashboard/admin/profile/'
    | '/_dashboard/admin/settings/'
    | '/_dashboard/admin/users/'
    | '/_dashboard/admin/comfort-trade/senders/$senderEmail'
    | '/_dashboard/admin/player-auction/senders/$senderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardDashboardRoute: typeof DashboardDashboardRoute
  LoginForgetPasswordRoute: typeof LoginForgetPasswordRoute
  LoginLoginRoute: typeof LoginLoginRoute
  LoginOtpRoute: typeof LoginOtpRoute
  LoginSignupRoute: typeof LoginSignupRoute
  TelegramConnectRoute: typeof TelegramConnectRoute
  DashboardProfileTransferMultiplierGuideRoute: typeof DashboardProfileTransferMultiplierGuideRoute
  DashboardHistoryIndexRoute: typeof DashboardHistoryIndexRoute
  DashboardPaymentHistoryIndexRoute: typeof DashboardPaymentHistoryIndexRoute
  DashboardProfileIndexRoute: typeof DashboardProfileIndexRoute
  DashboardSellCoinIndexRoute: typeof DashboardSellCoinIndexRoute
  DashboardWalletIndexRoute: typeof DashboardWalletIndexRoute
  DashboardAdminUsersUserIdRoute: typeof DashboardAdminUsersUserIdRoute
  DashboardAdminBannersIndexRoute: typeof DashboardAdminBannersIndexRoute
  DashboardAdminComfortTradeIndexRoute: typeof DashboardAdminComfortTradeIndexRoute
  DashboardAdminDashboardIndexRoute: typeof DashboardAdminDashboardIndexRoute
  DashboardAdminFastSellIndexRoute: typeof DashboardAdminFastSellIndexRoute
  DashboardAdminFinancialReportIndexRoute: typeof DashboardAdminFinancialReportIndexRoute
  DashboardAdminPlayerAuctionIndexRoute: typeof DashboardAdminPlayerAuctionIndexRoute
  DashboardAdminProfileIndexRoute: typeof DashboardAdminProfileIndexRoute
  DashboardAdminSettingsIndexRoute: typeof DashboardAdminSettingsIndexRoute
  DashboardAdminUsersIndexRoute: typeof DashboardAdminUsersIndexRoute
  DashboardAdminComfortTradeSendersSenderEmailRoute: typeof DashboardAdminComfortTradeSendersSenderEmailRoute
  DashboardAdminPlayerAuctionSendersSenderIdRoute: typeof DashboardAdminPlayerAuctionSendersSenderIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram/connect': {
      id: '/telegram/connect'
      path: '/telegram/connect'
      fullPath: '/telegram/connect'
      preLoaderRoute: typeof TelegramConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login/signup': {
      id: '/_login/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof LoginSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login/otp': {
      id: '/_login/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof LoginOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login/login': {
      id: '/_login/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login/forgetPassword': {
      id: '/_login/forgetPassword'
      path: '/forgetPassword'
      fullPath: '/forgetPassword'
      preLoaderRoute: typeof LoginForgetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/dashboard': {
      id: '/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/wallet/': {
      id: '/_dashboard/wallet/'
      path: '/wallet'
      fullPath: '/wallet/'
      preLoaderRoute: typeof DashboardWalletIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/sell-coin/': {
      id: '/_dashboard/sell-coin/'
      path: '/sell-coin'
      fullPath: '/sell-coin/'
      preLoaderRoute: typeof DashboardSellCoinIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/profile/': {
      id: '/_dashboard/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof DashboardProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/payment-history/': {
      id: '/_dashboard/payment-history/'
      path: '/payment-history'
      fullPath: '/payment-history/'
      preLoaderRoute: typeof DashboardPaymentHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/history/': {
      id: '/_dashboard/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof DashboardHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/profile/transfer-multiplier-guide': {
      id: '/_dashboard/profile/transfer-multiplier-guide'
      path: '/profile/transfer-multiplier-guide'
      fullPath: '/profile/transfer-multiplier-guide'
      preLoaderRoute: typeof DashboardProfileTransferMultiplierGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/users/': {
      id: '/_dashboard/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof DashboardAdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/settings/': {
      id: '/_dashboard/admin/settings/'
      path: '/admin/settings'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof DashboardAdminSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/profile/': {
      id: '/_dashboard/admin/profile/'
      path: '/admin/profile'
      fullPath: '/admin/profile/'
      preLoaderRoute: typeof DashboardAdminProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/player-auction/': {
      id: '/_dashboard/admin/player-auction/'
      path: '/admin/player-auction'
      fullPath: '/admin/player-auction/'
      preLoaderRoute: typeof DashboardAdminPlayerAuctionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/financial-report/': {
      id: '/_dashboard/admin/financial-report/'
      path: '/admin/financial-report'
      fullPath: '/admin/financial-report/'
      preLoaderRoute: typeof DashboardAdminFinancialReportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/fast-sell/': {
      id: '/_dashboard/admin/fast-sell/'
      path: '/admin/fast-sell'
      fullPath: '/admin/fast-sell/'
      preLoaderRoute: typeof DashboardAdminFastSellIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/dashboard/': {
      id: '/_dashboard/admin/dashboard/'
      path: '/admin/dashboard'
      fullPath: '/admin/dashboard/'
      preLoaderRoute: typeof DashboardAdminDashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/comfort-trade/': {
      id: '/_dashboard/admin/comfort-trade/'
      path: '/admin/comfort-trade'
      fullPath: '/admin/comfort-trade/'
      preLoaderRoute: typeof DashboardAdminComfortTradeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/banners/': {
      id: '/_dashboard/admin/banners/'
      path: '/admin/banners'
      fullPath: '/admin/banners/'
      preLoaderRoute: typeof DashboardAdminBannersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/users/$userId': {
      id: '/_dashboard/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof DashboardAdminUsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/player-auction/senders/$senderId': {
      id: '/_dashboard/admin/player-auction/senders/$senderId'
      path: '/admin/player-auction/senders/$senderId'
      fullPath: '/admin/player-auction/senders/$senderId'
      preLoaderRoute: typeof DashboardAdminPlayerAuctionSendersSenderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/comfort-trade/senders/$senderEmail': {
      id: '/_dashboard/admin/comfort-trade/senders/$senderEmail'
      path: '/admin/comfort-trade/senders/$senderEmail'
      fullPath: '/admin/comfort-trade/senders/$senderEmail'
      preLoaderRoute: typeof DashboardAdminComfortTradeSendersSenderEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardDashboardRoute: DashboardDashboardRoute,
  LoginForgetPasswordRoute: LoginForgetPasswordRoute,
  LoginLoginRoute: LoginLoginRoute,
  LoginOtpRoute: LoginOtpRoute,
  LoginSignupRoute: LoginSignupRoute,
  TelegramConnectRoute: TelegramConnectRoute,
  DashboardProfileTransferMultiplierGuideRoute:
    DashboardProfileTransferMultiplierGuideRoute,
  DashboardHistoryIndexRoute: DashboardHistoryIndexRoute,
  DashboardPaymentHistoryIndexRoute: DashboardPaymentHistoryIndexRoute,
  DashboardProfileIndexRoute: DashboardProfileIndexRoute,
  DashboardSellCoinIndexRoute: DashboardSellCoinIndexRoute,
  DashboardWalletIndexRoute: DashboardWalletIndexRoute,
  DashboardAdminUsersUserIdRoute: DashboardAdminUsersUserIdRoute,
  DashboardAdminBannersIndexRoute: DashboardAdminBannersIndexRoute,
  DashboardAdminComfortTradeIndexRoute: DashboardAdminComfortTradeIndexRoute,
  DashboardAdminDashboardIndexRoute: DashboardAdminDashboardIndexRoute,
  DashboardAdminFastSellIndexRoute: DashboardAdminFastSellIndexRoute,
  DashboardAdminFinancialReportIndexRoute:
    DashboardAdminFinancialReportIndexRoute,
  DashboardAdminPlayerAuctionIndexRoute: DashboardAdminPlayerAuctionIndexRoute,
  DashboardAdminProfileIndexRoute: DashboardAdminProfileIndexRoute,
  DashboardAdminSettingsIndexRoute: DashboardAdminSettingsIndexRoute,
  DashboardAdminUsersIndexRoute: DashboardAdminUsersIndexRoute,
  DashboardAdminComfortTradeSendersSenderEmailRoute:
    DashboardAdminComfortTradeSendersSenderEmailRoute,
  DashboardAdminPlayerAuctionSendersSenderIdRoute:
    DashboardAdminPlayerAuctionSendersSenderIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
